// Babylon-free product/garment type predicates. Extracted out of utils/meshUtils
// (which statically imports the @babylonjs/core Legacy barrel) so that always-mounted
// UI and the turntable container can classify products WITHOUT dragging the entire
// Babylon engine into main.js. meshUtils keeps only its Babylon mesh/skeleton helpers.
import { GARMENT_TYPE } from "utils/constants";

export const isTopGarment = (garmentType) => {
  return garmentType === GARMENT_TYPE.TOP;
};

export const isBottomGarment = (garmentType) => {
  return garmentType === GARMENT_TYPE.BOTTOM;
};

export const isShoeProduct = (product) => {
  return product?.primary === "shoes";
};

export const isBraProduct = (product) => {
  return product?.primary === "bra";
};
